{
  "languageFlag": "🇬🇧",
  "languageFull": "🇬🇧 English",
  "languages": {
    "fr": "French (Français)",
    "en": "English"
  },
  "impersonationWarning": "You are currently impersonating a user",
  "activity": {
    "title": "Physical activity",
    "intensity": "Intensity",
    "duration": "Duration",
    "durationUnit": "min"
  },
  "admin": {
    "title": "Admin",
    "logout": "Logout"
  },
  "atoms": {
    "richText": {
      "h5": "Heading",
      "normal": "Normal"
    }
  },
  "button": {
    "cancel": "Cancel",
    "validate": "Validate",
    "back": "Back",
    "next": "Next",
    "pending": "Loading",
    "submit": "Submit",
    "reject": "Reject",
    "accept": "Accept",
    "edit": "Edit",
    "tryAgain": "Try again",
    "save": "Save",
    "upload": "Upload",
    "generate": "Generate"
  },
  "carePlans": {
    "history": "History",
    "historyTitle": "Prescription history",
    "historyPrescriptionTitle": "Prescription",
    "historyPeriodTitle": "Period",
    "historyTelemonitoringTierTitle": "Level",
    "historyTelemonitoringCriteriaTitle": "Inclusion criteria",
    "historyObjectivesTitle": "Objectives",
    "noCarePlans": "No prescription found",
    "copyDescription": "Copy objectives"
  },
  "clipboard": {
    "unsupported": "Clipboard copy is not available",
    "copied": "Content copied to clipboard",
    "failed": "Failed to copy content to clipboard"
  },
  "fileReports": {
    "noData": "No available report for these dates"
  },
  "condition": {
    "unspecified": "Unspecified",
    "term": "Term"
  },
  "devices": {
    "sensor": "Interstitial Sensor",
    "reader": "Reader",
    "pump": "Insulin Pump",
    "manual": "Manual",
    "pen": "Insulin Pen",
    "libreLink": "Via LibreView",
    "upload": "Upload",
    "cancel": "Cancel",
    "uploadSuccess": "Upload successful",
    "uploadError": "Upload error",
    "uploadErrorDescription": "Please try again or contact support if the problem persists.",
    "uploadPaused": "Upload paused",
    "lastUpload": "Last Upload",
    "neverUploaded": "Never",
    "noDeviceFound": "No device found",
    "deviceDetected": "Device detected",
    "manyDevicesDetected": "{{count}} devices detected. Please connect only one device.",
    "tandem": {
      "name": "Tandem",
      "instructions": "Connect the pump with the USB cable then click on '$t(devices.tandem.upload)'",
      "instructionsNoDevices": "Connect the pump with the USB cable then click on '$t(devices.tandem.searchForDevice)'",
      "searchForDevice": "Search for a pump",
      "upload": "Upload",
      "noDeviceFound": "No device found",
      "deviceDetected": "Pump detected",
      "manyDevicesDetected": "{{count}} pumps detected. Please connect only one pump."
    },
    "omnipod": {
      "name": "Omnipod",
      "instructions": "Connect the PDM with the USB cable then click on '$t(devices.omnipod.upload)'",
      "instructionsNoDevices": "Connect the PDM with the USB cable then click on '$t(devices.omnipod.searchForDevice)'",
      "searchForDevice": "Search for a device",
      "upload": "Upload",
      "noDeviceFound": "No PDM found",
      "deviceDetected": "PDM detected",
      "manyDevicesDetected": "{{count}} PDMs detected. Please connect only one PDM.",
      "uploadManually": "or select the file manually"
    },
    "errors": {
      "driverInit": "Error connecting to the device, please try again",
      "dataRead": "Error reading data from the device, please try again",
      "connectionFailure": "Failed to connect to the device, please check the USB connection and try again",
      "cancelled": "Upload cancelled"
    },
    "pause": {
      "usbConnectionLost": "Connection lost. Please check the usb cable is connected on both ends"
    }
  },
  "diabetesForms": {
    "telemonitoring": "Telemonitoring",
    "diabetesType": "Diabetes type",
    "insulinScheme": "Insulin delivery method",
    "insulin": {
      "insulinPen": "Insulin pen",
      "insulinPump": "Insulin pump",
      "noInsulin": "No insulin",
      "insulinPumpsComingSoon": "Insulin pumps will be available soon on Stēto"
    },
    "criteria": "Telemonitoring criteria",
    "criteriaBase": "Base",
    "criteriaBaseInfo": "Monitoring of a patient with type 1 diabetes, initiation of basal insulin in a type 2 diabetic, monitoring of type 2 diabetes under multi-injections",
    "criteriaLevel1": "Level 1",
    "criteriaLevel1Info": "Discovery of type 1 diabetes in an adult patient, \nmonitoring of type 1 diabetes in an adolescent patient, \ntransient imbalances (corticosteroid therapy), \nmonitoring of gestational diabetes",
    "criteriaLevel2": "Level 2",
    "criteriaLevel2Info": "Discovery of type 1 diabetes in an adolescent patient, \nmonitoring of adolescents in care gaps, \npregnancy of a diabetic woman",
    "criteriaMeaningBase": "This inclusion criterion corresponds to a base-level doctor reimbursement",
    "criteriaMeaningLevel1": "This inclusion criterion corresponds to a level 1 doctor reimbursement",
    "criteriaMeaningLevel2": "This inclusion criterion corresponds to a level 2 doctor reimbursement",
    "goals": "Therapeutic goals and care process",
    "goalsShort": "Therapeutic goals",
    "goalsNone": "No therapeutic goals",
    "termDate": "Term date",
    "nonTelemonitoredPatient": "Non-telemonitored patient",
    "noInsulinMonitoringHelpText": "Gestational diabetes without insulin is not eligible for reimbursed telemonitoring. The patient will therefore not be assisted by your nurse, but it will still be possible to offer her nursing support if she begins insulin therapy.",
    "addInsulin": "Add insulin",
    "prescription": "Prescription",
    "prescriptionDescription": "or add a prescription for three months starting on",
    "prescriptionGeneration": "Prescription generation",
    "prescriptionDownload": "Download the prescription",
    "prescriptionSignSuccess": "The prescription has been signed",
    "prescriptionNone": "No prescription",
    "addPrescription": "Add a prescription",
    "generatePrescription": "Generate a prescription",
    "prescriptionDuration": "Duration of the telemonitoring",
    "prescriptionAddition": "Addition of the prescription",
    "prescriptionSignature": "Signature",
    "addDescription": "Add therapeutic goals",
    "weight": "Weight (kg)",
    "weightUnit": "kg",
    "months": "months",
    "prescriptionLabel": "Add a file",
    "prescriptionTooltip": "The prescription must include the following elements:\n\n- patient's name\n- age\n- weight\n- designation “diabetes telemonitoring”\n- duration: 3 months\n- platform: Stēto",
    "periodStart": "Start date",
    "duration": "Telemonitoring duration (in months)",
    "dates": "Ongoing telemonitoring",
    "renew": "Renew the telemonitoring",
    "restartMonitoring": "Restart monitoring",
    "renewed": "Renewed",
    "hasUntilTerm": "Renewed until term",
    "restriction": "This patient has already been monitored for 6 consecutive months at level 1 or 2. Therefore, only the basic level of monitoring is available.",
    "responsibleDoctor": "Doctor",
    "responsibleNurse": "Nurse",
    "inclusionCriteriaLabel": {
      "adultMonitoringD1": "Monitoring of T1D in an adult",
      "adultDiscoveryD1": "Discovery of T1D in an adult",
      "teenMonitoringD1": "Monitoring of T1D in a teenager",
      "teenDiscoveryD1": "Discovery of T1D in a teenager",
      "corticotherapie": "Situation of transient imbalances",
      "teenCareGap": "Monitoring of teenagers with care gaps",
      "pregnateD": "Grossesse d'une femme diabétique",
      "gestational": "Pregnancy in a diabetic woman",
      "startBasalD2": "Initiation of basal insulin in a T2D",
      "monitoringD2": "Monitoring of T2D on insulin",
      "gestationalInsulined": "Gestational diabetes on insulin",
      "pumpMonitoring": "Monitoring of a treatment by insulin pump",
      "pumpInitiation": "Initiation of a treatment by insulin pump",
      "pumpHybridInitiation": "Initiation of a hybrid pump treatment",
      "basePrice": "Base Rate",
      "level1Price": "Level 1 Rate",
      "level2Price": "Level 2 Rate",
      "noRefund": "Not Reimbursed"
    },
    "supportedPumpsTitle": "Available pumps on Stēto",
    "hsp": "HealthCare Provider",
    "addProvider": "New Provider",
    "otherHSP": "New provider - Stēto will contact you",
    "eitherObjectiveOrFile": "Therapeutic goals must be filled in and/or a file must be added",
    "minimumWeight": "Weight must be greater than 0 kg",
    "maximumWeight": "Weight must be less than 1000 kg",
    "signAndAddPatient": "Sign and add patient",
    "signAndRenewPatient": "Sign and renew patient",
    "addPatient": "Add patient",
    "addNurseInclusion": "Pré-inclure un patient",
    "renewPatient": "Renew patient",
    "medtronicSupportedPumps": "<0>Medtronic: </0><1>MiniMed 630G, 640G and 780G </1><2>(new)</2>",
    "insuletSupportedPumps": "Insulet: Omnipod Dash and Omnipod Eros",
    "tandemSupportedPumps": "<0>Tandem: t:slim X2 and </0><1>t:slim X2 Control IQ</1><2>(new)</2>",
    "supportedPumpsInfo": "New pumps will be added regularly in the coming months",
    "patientCreated": "Patient has been successfully created",
    "clickToView": "Click to view the patient"
  },
  "errors": {
    "title": "Error",
    "waitAFewMinutes": "Please wait a few minutes",
    "or": "or",
    "unknownError": "A technical error occurred",
    "userAlreadyExists": "This patient already has an account, please contact {{supportEmail}}",
    "accountAlreadyExists": "This patient already has an account, please contact support.",
    "carePlansOverlapping": "The telemonitoring dates overlap with the current telemonitoring",
    "carePlanAlreadyRenewed": "The telemonitoring has already been renewed",
    "fileSizeError": "The file size must not exceed {{max_size}}: {{size}} / {{max_size}}",
    "dateFormat": "The date format is incorrect",
    "unauthorizedPatientAccess": "The patient does not exist or you do not have permission to view this patient",
    "pageNotFound": "Page does not exist",
    "emailAlreadyInUse": "This email is already in use by one of your patients",
    "unknownErrorFull": "A technical error has occurred. Please contact support.",
    "invalidEmail": "This email address is not valid",
    "invalidPhone": "This phone number is not valid",
    "invalidCode": "The code must be 6 digits",
    "tooManyAttempts": "Too many attempts, please wait a few minutes",
    "wrongCode": "The code is incorrect or has expired"
  },
  "food": {
    "title": "Meal",
    "carbs": "Carbs",
    "carbsUnit": "g",
    "meal": "Meal",
    "size": "Size",
    "comments": "Commentaire"
  },
  "form": {
    "required": "The field is required",
    "atLeastOne": "At least one field must be filled",
    "pastDate": "The date cannot be in the past",
    "email": {
      "label": "Email address",
      "required": "An email address is required",
      "invalid": "Invalid email address"
    },
    "text": {
      "required": "The field is required",
      "firstnameRequired": "The first name is required",
      "lastnameRequired": "The last name is required",
      "comment": "Comment"
    },
    "number": {
      "invalid": "The field must be a number",
      "integer": "The field must be an integer",
      "positive": "The field must be positive",
      "min": "The field is less than the minimum value",
      "max": "The field is greater than the maximum value"
    },
    "phone": {
      "label": "Phone number",
      "required": "A phone number is required",
      "invalid": "Invalid phone number"
    },
    "helperPhone": {
      "label": "Helper phone number"
    },
    "file": {
      "label": "File",
      "required": "Only files of the following type are supported : {{extensions}}",
      "tooBig": "The file must not be bigger than 10 MB"
    },
    "date": {
      "invalid": "Invalid date",
      "future": "Date must be in the past",
      "past": "Date must be in the future"
    }
  },
  "glycemia": {
    "title": "Glucose",
    "hyperglycemia_one": "Hyperglycemia",
    "hyperglycemia_other": "Hyperglycemias",
    "hypoglycemia_one": "Hypoglycemia",
    "hypoglycemia_other": "Hypoglycemias"
  },
  "identityValidation": {
    "title": "Validate patients identities",
    "subtitle": "The identities of the patients below must be validated before you can continue"
  },
  "nurseInclusion": {
    "doctorSelect": "Telemonitoring doctor",
    "patientInfo": "Patient information",
    "banner": "The patient will receive a login email once the doctor has validated the inclusion",
    "inclusionReason": "Reason for inclusion suggestion",
    "inclusionSent": "Suggestion sent successfully",
    "inclusionProposal": "Inclusion suggestion",
    "inclusionProposalBy": "Inclusion suggested by {{nurse}}",
    "examineSuggestion": "Examine the request",
    "reject": "Reject",
    "accept": "Validate the suggestion",
    "addPatient": "Inclusion suggested by {{nurse}}",
    "history": {
      "title": "Inclusion suggestion history",
      "createdAt": "Suggestion date",
      "doctor": "Doctor",
      "name": "Patient name",
      "birthDate": "Birth date",
      "email": "Email address",
      "status": "Inclusion status"
    }
  },
  "insulin": {
    "title": "Insulin",
    "fastInsulinPerDay": "Fast insulin / day",
    "slowInsulinPerDay": "Slow insulin / day",
    "bolusInsulinPerDay": "Bolus insulin / day",
    "basalInsulinPerDay": "Basal insulin / day",
    "averageInsulinPerDay": "Avg. insulin / day",
    "averageNbInjectionsPerDay": "Avg. nb. injections / day",
    "averageNbBolusInjectionsPerDay": "Avg. nb. bolus / day",
    "averageNbBolusPerDay": "Avg. nb. bolus / day",
    "suggested": "Suggested",
    "quantity": "Delivered",
    "type": "Type",
    "reason": "Reason",
    "suggestedFoodInsulin": "Suggested meal",
    "foodInsulin": "Meal",
    "carbs": "Carbs",
    "carbsRatio": "Ratio",
    "suggestedCorrection": "Suggested Cor.",
    "correction": "Correction",
    "glycemia": "Glycemia",
    "insulinSensitivity": "Sensitivity",
    "targetGlycemia": "Target glycemia",
    "iob": "Active insulin"
  },
  "insulinPump": {
    "total": "Total",
    "timeRange": "",
    "basalRate": "Basal rate",
    "carbsRatio": "Ratio",
    "insulinSensitivity": "Sensitivity",
    "activeInsulinTime": "Active insulin time",
    "targetBloodGlucose": "Target glycemia",
    "profiles": "Pump parameters",
    "model": "Model",
    "lastUpload": "Last upload",
    "profile": "Profile",
    "units": {
      "basalRate": "U/h",
      "carbsRatio": "g/U",
      "insulinSensitivity": "mg/dL/U",
      "activeInsulinTime": "min",
      "targetBloodGlucose": "mg/dL"
    }
  },
  "messaging": {
    "me": "Me",
    "everybody": "Everybody",
    "all": "Every messages",
    "medicalStaff": "Medical staff",
    "recipient": "Recipient",
    "toAllPlaceholder": "Message visible to the patient and the medical team",
    "toPractitionerPlaceholder": "Message visible to the medical team only",
    "noNurse": "Patient has no nurse",
    "patientOnly": "Message for your patient only",
    "deleted": "Message deleted",
    "unread": "Unread",
    "noMessages": "No messages for now",
    "readBy": "Read by"
  },
  "patientEvents": {
    "carePlanDeleted": "Unable to connect the patient, their monitoring has been terminated.",
    "header": "Évènement",
    "decidedNotToRenew": {
      "beforeEndCP": {
        "self": "You have ended the patient's telemonitoring, at the end of the current prescription",
        "other": "{{doctorName}} has decided not to renew the telemonitoring at the end of the current prescription."
      },
      "afterEndCP": {
        "self": "You have ended the patient's telemonitoring",
        "other": "{{doctorName}} has decided not to renew the telemonitoring."
      }
    },
    "carePlanRenewed": {
      "self": "You have renewed the patient's telemonitoring",
      "other": "{{doctorName}} has renewed the telemonitoring."
    },
    "aircall": {
      "callNotAnswered": "Call attempt to the patient by the Stēto team",
      "callAnswered": "Call between the Stēto team and the patient - Duration: {{duration}} minutes",
      "smsSentBySteto": "SMS sent to the patient by the Stēto team",
      "smsSentByPatient": "SMS sent by the patient to the Stēto team"
    }
  },
  "navbar": {
    "myPatients": "My patients",
    "disconnect": "Disconnect",
    "practitionerBilling": "Billing"
  },
  "notifications": {
    "title": "Active notifications",
    "none": "No active notifications"
  },
  "pages": {
    "notFound": {
      "title": "Page not found"
    },
    "addMeasurement": {
      "choose": "Choose"
    },
    "account": {
      "title": "My account",
      "about": {
        "title": "About Stēto",
        "description": "Stēto is a regulated health product that carries, under this regulation, a CE marking of class I. See instructions for use. The Stēto application is a diabetes telemonitoring solution made and developed by :",
        "name": "Stēto",
        "address": "12 Boulevard de Port Royal",
        "postCode": "75005 Paris",
        "rcs": "918012121 RCS de Paris",
        "class": "Class I medical device"
      },
      "generalInformation": {
        "title": "General information"
      },
      "preferences": {
        "title": "Email notification preferences",
        "nursePing": "Patient reported",
        "nurseToDoctor": "New message from a nurse",
        "patientToNurse": "New message from a patient",
        "doctorToNurse": "New message from a doctor",
        "dgNoInsulinPatientToDoctor": "New message from a DG patient that has no nurse",
        "patientExpiresSoon": "Patient telemonitoring expires soon",
        "patientExpiresSoonNurse": "Patient telemonitoring expires soon"
      },
      "language": {
        "title": "Language"
      },
      "security": {
        "title": "Sécurity",
        "updatePassword": "Change my password"
      },
      "terms": {
        "title": "Terms of use"
      },
      "userHelp": {
        "title": "Need help ?",
        "description": "Need help  ?",
        "contactUs": "Contact us at {{supportEmail}}",
        "or": "or",
        "userManual": "consult our user manual"
      }
    },
    "search": {
      "title": "Recherche d'antériorité",
      "CTA": "Chercher",
      "CTARedirectButton": "Rechercher un patient",
      "form": {
        "dob": "Date de naissance (AAAA-MM-JJ)",
        "NIR": "Numéro NIR",
        "names": "Nom / Prénom(s)"
      },
      "table": {
        "birth_name": "Nom de naissance",
        "used_last_name": "Nom utilisé",
        "first_regulatory_first_name": "Premier prénom de naissance",
        "used_first_name": "Prénom utilisé",
        "dob": "Date de naissance",
        "gender": "Sexe",
        "status": "Statut de l’identité",
        "nir": "Numéro NIR",
        "CTA": "Voir",
        "noData": "Aucun résultat"
      }
    },
    "patientMonitoring": {
      "title": "Patient monitoring",
      "noData": "No data to display",
      "loadMoreRecent": "Load more recent data",
      "agp": {
        "title": "AGP profile",
        "glycemiaMgDl": "Glycemia (mg/dL)",
        "longTermEvolution": "See long-term evolution"
      },
      "glycemia": {
        "title": "Daily glycemia profiles",
        "estimatedHba1c": "Estimated HbA1c",
        "averageReader": "Avg. gluc. reader",
        "averageSensor": "Avg. gluc. sensor",
        "averageMeasuresPerDay": "Avg. measures/day",
        "nbHypo": "Nb. hypo",
        "coefVariation": "Coef. variation",
        "sensorUsage": "Sensor usage"
      },
      "insulin": {
        "slow": "Slow insulin",
        "fast": "Fast insulin",
        "averageInsulinPerDay": "Avg. insulin/day",
        "averageNbInjectionsPerDay": "Avg. nb. injections/day",
        "averageNbBolusPerDay": "Avg. nb. bolus/day"
      },
      "patient": {
        "title": "Patient information",
        "helperSection": "Helper to contact (optional)",
        "age": "{{age}} years",
        "diabetes": {
          "type1": "Diabète type 1",
          "type2": "Diabète type 2",
          "gestational": "Diabète gestationnel"
        },
        "insulin": {
          "noInsulin": "No insulin",
          "insulinPen": "Insulin pen",
          "insulinPump": "Insulin pump"
        },
        "insulinScheme": "Insulin delivery method",
        "unspecifiedInsulinScheme": "Insulin scheme not specified",
        "unspecifiedDiabetesType": "Diabetes type not specified"
      },
      "dailyDataError": "Error while loading daily data"
    },
    "patientMedicalFile": {
      "diabetes": {
        "title": "Diabetes"
      },
      "devices": "Medical devices",
      "lastSync": "Latest data",
      "neverSynced": "never",
      "thereIs": "{{duration}} ago",
      "notes": "Medical team notes",
      "emptyNote": "\"<i>You do not have any notes for this patient yet</i>\"",
      "editNote": "Edit note",
      "writeNote": "Write a note",
      "noteSuccess": "Note saved successfully"
    },
    "addMeasurementFile": {
      "dexcom": {
        "title": "Dexcom",
        "integrationSuccess": "Dexcom integration successful",
        "integrationSuccessHelpText": "Your Dexcom account has been successfully integrated. You can now view your data in the Stēto application.",
        "integrationError": "An error occurred during Dexcom integration",
        "integrationErrorHelpText": "An error occurred while connecting to your Dexcom account. We recommend trying again in a few minutes. If it still doesn't work, you can contact support at {{supportPhone}} or email us at {{supportEmail}}",
        "alreadyIntegrated": "Dexcom is already integrated",
        "alreadyIntegratedHelpText": "You have already integrated your Dexcom account. If you wish to reset it, you can contact support at {{supportPhone}} or email us at {{supportEmail",
        "integrationDenied": "Dexcom integration was denied",
        "integrationDeniedHelpText": "You have denied access to your Dexcom account. You need to accept the connection to view your data in the Stēto application.",
        "dexcomData": "Dexcom CGM",
        "clarityNotEnabled": "Clarity sharing is not enabled",
        "clarityNotEnabledHelpText": "You must first enable the sharing of your data with third-party applications in the Dexcom Clarity application. To do this, go to the Dexcom Clarity application, then to the settings, and finally to the sharing section."
      },
      "chooseFile": "Choose a file",
      "chooseMedicalDeviceToLoad": "Choose my medical device to download",
      "error": "An error occurred while saving your file",
      "fsl": {
        "addData": "Download data from my FreeStyle Libre",
        "instructions": "You must first go to the LibreView website to retrieve your CSV data file. Then select the file:"
      },
      "fslWithAbbottSmartphone": "FreeStyle Libre sensor scanned with my ABBOTT smartphone",
      "noFileChosen": "No file chosen",
      "success": "Your file has been saved"
    },
    "patientSettings": {
      "telemonitoring": {
        "title": "Diabetes and telemonitoring registration",
        "activate": "Activate telemonitoring",
        "edit": "Edit telemonitoring"
      }
    },
    "login": {
      "practitionerTitle": "You are a healthcare provider",
      "practitionerInstructions": "Access your healthcare provider space on the Stēto web application via this link: ",
      "patientTitle": "You are a patient",
      "emailLabel": "Email address",
      "phoneLabel": "Phone number",
      "emailPlaceholder": "first.last@example.com",
      "phonePlaceholder": "06 12 34 56 78",
      "requestEmailCode": "Get a code by email",
      "requestSmsCode": "Get a code by SMS",
      "switchToEmail": "Use my email address instead",
      "switchToSms": "Use my phone number instead",
      "codeTitle": "Enter your code",
      "codeSentTo": "We sent a code to {{contact}}.",
      "codeLabel": "6-digit code",
      "codePlaceholder": "123456",
      "codeValidity": "The code is valid for 15 minutes.",
      "submitCode": "Sign in",
      "resendCode": "Send a new code",
      "changeContact": "Change my details",
      "codeSentToast": "Code sent",
      "connection": "Sign in",
      "back": "Back"
    },
    "patients": {
      "title": "My patients",
      "addPatient": "Add a patient",
      "addNurseInclusion": "Pré-inclure un patient",
      "editPatient": "Edit",
      "patientInfo": "Information about the patient",
      "notifications": "Telemonitoring",
      "toConsult": "Patient reported",
      "messages": "Messages",
      "diabetesType": "Diabetes",
      "telemonitoring": "Telemonitoring",
      "monitored": "Active T1/2D",
      "gestational": "Active GD",
      "all": "All",
      "referentDoctor": "Doctor"
    },
    "renewPopup": {
      "title": "Renwal of your patient",
      "body": "The remote monitoring of your patient has expired, and they are no longer being assisted by your nurse. Would you like to continue their support?",
      "yes": "Yes",
      "no": "No",
      "decideLater": "Decide later"
    },
    "practitionerBilling": {
      "title": "Billing",
      "fileName": "File name",
      "period": "Period",
      "lastUpdate": "Last update",
      "status": "Status",
      "noData": "No available file"
    }
  },
  "patientInfo": {
    "noPhoneNumber": "Phone number not provided",
    "placeOfBirth": "Born in",
    "placeOfBirth_female": "Born in",
    "placeOfBirth_male": "Born in",
    "countryOfBirth": "Born in",
    "countryOfBirth_female": "Born in",
    "countryOfBirth_male": "Born in"
  },
  "patientNavigation": {
    "lastSeen": "Last seen",
    "medicalFile": "Medical file",
    "noFirstConnection": "No first connection",
    "monitoring": "Diabetes monitoring",
    "settings": "Telemonitoring",
    "dailyView": "Daily view",
    "notice": {
      "notifyDoctor": "Report to the doctor",
      "cancelNotify": "Cancel the report",
      "mitigateNotify": "Validate the report",
      "notified": "Patient reported",
      "banner": "Your nurse has reported this patient"
    },
    "reinclusion": {
      "doctorTitle": "Votre infirmier vous propose de réinclure ce patient",
      "doctorTitleWithNurseName": "{{nurseName}} vous propose de réinclure ce patient",
      "doctorCTAAccept": "Réinclure",
      "doctorCTADeny": "Refuser"
    },
    "reinclusionNudge": {
      "title": "Télésurveillance expirée. Souhaitez-vous proposer au médecin de réinclure ce patient ?",
      "titleReinclusionAlreadyCreated": "Vous avez proposé au médecin de réinclure ce patient",
      "subtitle": "Ce patient n’est plus télésuivi depuis le",
      "nurseCTACreate": "Proposer la réinclusion",
      "nurseCTACancel": "Annuler la proposition"
    },
    "renewalNudge": {
      "expires_today": "<0>L’ordonnance de {{patientName}} expire aujourd’hui.</0> Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expires_tomorrow": "<0>L’ordonnance de {{patientName}} expire demain.</0> Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expires_soon": "<0>L’ordonnance de {{patientName}} expire dans {{days}} jours.</0> Prévenez votre infirmier si il doit continuer d’accompagner votre patient à l’issue de la prescription en cours.",
      "expired": "<0>L’ordonnance de {{patientName}} a expiré il y a {{days}} jours.</0> Prévenez votre infirmier si il doit arrêter d’accompagner votre patiente.",
      "expired_yesterday": "<0>L’ordonnance de {{patientName}} a expiré hier.</0> Prévenez votre infirmier si il doit arrêter d’accompagner votre patiente.",
      "ctas": {
        "continue": "Poursuivre le suivi",
        "stop_later": "Arrêter le suivi dans {{days}} jours",
        "stop_tomorrow": "Arrêter le suivi demain",
        "stop_today": "Arrêter le suivi aujourd'hui",
        "stop_now": "Mettre un terme au suivi"
      }
    },
    "dataManagement": "Data management"
  },
  "periodicity": {
    "customize": "{{count}} days",
    "yesterday": "Yesterday",
    "oneWeek": "7 days",
    "twoWeeks": "14 days",
    "oneMonth": "30 days",
    "threeMonths": "90 days",
    "sixMonths": "180 days"
  },
  "prescription": {
    "sign": "Signe",
    "renew": "Renew"
  },
  "profile": {
    "address": "Address",
    "birth": "Birth information",
    "birthCity": "Birth city",
    "birthCountry": "Birth country",
    "birthDate": "Birth date",
    "birthDate_short": "Birth",
    "birthPlace": "Birth place",
    "birthPostCode": "Birth post code",
    "diabetologist": "Diabetologist",
    "doctor": "Doctor",
    "email": "Email",
    "female": "Female",
    "firstname": "Used firstname",
    "gender": "Gender",
    "identityFirstname": "First birth firstname",
    "identityFirstnames": "Birth firstname",
    "identityLastname": "Birth lastname",
    "ins": "National Health Identifier",
    "lastname": "Used lastname",
    "male": "Male",
    "moreInfo": "Show all information",
    "notGiven": "Not given",
    "nurse": "Nurse",
    "oid": "OID number",
    "phone": "Phone number",
    "profession": "Profession",
    "profile": "Profile",
    "ssn": "Social Security Number",
    "title": "Profile",
    "usedFirstname": "Used firstname",
    "usedLastname": "Used lastname"
  },
  "search": {
    "searchPatient": "Search a patient"
  },
  "support": {
    "contactUs": "Contact support",
    "byEmail": " by email at ",
    "or": "or",
    "byPhone": "by phone at",
    "inCaseOfNeed": "In case of need, you can contact support"
  },
  "report": {
    "title": "Event",
    "category": "Category",
    "message": "Message"
  },
  "thresholdSettings": {
    "thresholds": "Thresholds",
    "thresholdUpdated": "Threshold updated",
    "severeHyperglycemia": "Severe hyperglycemia",
    "hyperglycemia": "Hyperglycemia",
    "severeHypoglycemia": "Severe hypoglycemia",
    "hypoglycemia": "Hypoglycemia",
    "normal": "Target glycemia",
    "units": "mg/dL",
    "gestationalThresholds": "Glycemia thresholds",
    "beforeBreakfast": "Before breakfast",
    "beforeMeal": "Before meal",
    "afterMeal": "After meal",
    "alertThresholds": "Notification thresholds"
  },
  "pumpEvents": {
    "title": "Pump events",
    "category": "Event",
    "insulin": "Insulin",
    "primeSize": "Prime size",
    "tempRate": "Temp. rate",
    "tempRatePercent": "Temporary basal rate",
    "isTemp": "Yes",
    "isNotTemp": "No"
  },
  "inclusionAgent": {
    "title": "Inclusion proposals",
    "accept": "Suggest monitoring",
    "startTelemonitoring": "Start telemonitoring",
    "reject": "Decline",
    "cancel": "Cancel",
    "requiredPhone": "We need a phone number to propose monitoring to the patient",
    "inclusionRequestSent": "Monitoring request sent",
    "contactPatientTitle": "Patient contact",
    "contactPatient": "We will contact the patient and notify you of their choice",
    "rejected": "Monitoring request rejected",
    "disappear": "The patient will disappear from the list",
    "phonePlaceholder": "Phone number",
    "includePatient": "Add patient",
    "patientAccepted": "Monitoring accepted by patient",
    "viewOnLibreView": "View on LibreView",
    "stats": {
      "TBR": "TBR",
      "TIR": "TIR",
      "CV": "CV",
      "GMI": "GMI",
      "hypo_count": "Nb. Hypo"
    },
    "source": {
      "robot": "Agent",
      "tooltip": "Inclusion suggestion by Stēto Agent"
    },
    "noMoreSuggestions": "No inclusion proposals for the moment.",
    "lastStep": "Last step"
  },
  "models": {
    "activityIntensity": {
      "low": "Low",
      "medium": "Average",
      "high": "High",
      "unknown": "Unspecified"
    },
    "diabetesType": {
      "type1": "Type 1",
      "type2": "Type 2",
      "gestational": "Gestational",
      "gestationalNoInsulin": "GD no insulin",
      "gestationalWithInsulin": "GD with insulin"
    },
    "insulinType": {
      "slow": "Slow insulin",
      "fast": "Fast insulin",
      "slow_short": "Slow ins.",
      "fast_short": "Fast ins."
    },
    "insulinReason": {
      "bolus": "Bolus insulin",
      "basal": "Basal insulin",
      "bolus_short": "Bolus",
      "basal_short": "Basal"
    },
    "nurseInclusionPatientStatus": {
      "suggestedToDoc": "Suggested",
      "doctorRefused": "Refused",
      "patientIncluded": "Included",
      "unknown": "Unknown"
    },
    "medicationSchema": {
      "noInsulin": "No insulin",
      "insulinPen": "Insulin pen",
      "insulinPump": "Insulin pump"
    },
    "telemonitoringTag": {
      "active": "Active",
      "active_long": "Active telemonitoring",
      "expiringSoon": "Expires soon",
      "expiringSoon_long": "Telemonitoring expires soon",
      "expired": "Expired",
      "expired_long": "Expired telemonitoring",
      "expiredRecently": "Expired recently",
      "expiredRecently_long": "Telemonitoring expired recently",
      "onboarding": "Onboarding ongoing",
      "onboarding_long": "Patient onboarding is ongoing",
      "gestationalNoInsulin": "GD no insulin",
      "gestationalNoInsulin_long": "Gestational diabetes without insulin",
      "nurseAskedForReinclusion": "Reinclusion suggested",
      "nurseAskedForReinclusion_long": "Reinclusion suggested by nurse"
    },
    "meal": {
      "breakfast": "Breakfast",
      "lunch": "Lunch",
      "dinner": "Dinner",
      "snack": "Snack",
      "unknown": "Unspecified meal"
    },
    "mealSize": {
      "light": "Light",
      "medium": "Medium",
      "heavy": "Heavy",
      "unknown": "Unspecified"
    },
    "reportCategory": {
      "severeHypoglycemia": "Severe hypoglycemia",
      "perceivedHypoglycemia": "Perceived hypoglycemia",
      "perceivedHyperglycemia": "Perceived hyperglycemia",
      "techAlert": "Technical issues",
      "other": "Other"
    },
    "pumpEventCategory": {
      "cannulaFilled": "Cannula changed",
      "tubingFilled": "Tubing changed",
      "cartridgeFilled": "Cartridge changed",
      "profileChanged": "Pump profile changed",
      "podChanged": "Pod changed",
      "podActivated": "Pod activated",
      "podDeactivated": "Pod deactivated",
      "basalRateChanged": "Basal rate changed",
      "dailyBasal": "Daily basal"
    },
    "practitionerBillingStatus": {
      "toProcess": "To process",
      "processed": "Processed",
      "error": "Error"
    },
    "practitionerBillingType": {
      "retrocessionSteto": "Stēto retrocession",
      "retrocessionDoctor": "Doctor retrocession",
      "quotation": "Summaries for quotation"
    },
    "pumpMode": {
      "noControl": "Manual mode",
      "pining": "Manual mode",
      "openLoop": "Manual mode",
      "closedLoop": "Closed loop mode",
      "manual": "Manual mode"
    },
    "userMode": {
      "sleeping": "Sleep mode",
      "exercising": "Sport mode",
      "normal": "Normal mode"
    },
    "contactType": {
      "nurse": "Nurse",
      "family": "Family",
      "helper": "Helper",
      "unknown": "Other"
    },
    "contactRelationship": {
      "grandParent": "Grandparent",
      "parent": "Parent",
      "parentInLaw": "Parent-in-law",
      "partner": "Spouse",
      "child": "Child",
      "sibling": "Sibling",
      "cousin": "Cousin",
      "friend": "Friend",
      "unknown": "Other"
    }
  },
  "QaTools": {
    "glycemiaDataManagement": "Glycemia data management",
    "downloadCSVTitle": "Download glycemia data",
    "downloadCSV": "Download CSV",
    "uploadCSV": "Upload CSV",
    "uploadCSVTitle": "Upload glycemia data",
    "generateDataTitle": "Generate glycemia data",
    "generateData": "Generate",
    "deleteDataTitle": "Delete glycemia data",
    "deleteData": "Delete",
    "onboarding": "Onboarding management",
    "skipOnboarding": "Skip onboarding"
  },
  "appTitle": "Stēto Uploader",
  "chrome": "Chrome",
  "electron": "Electron",
  "uploader": "Uploader",
  "version": "Version",
  "auth": {
    "login": "Login",
    "logout": "Logout",
    "issues": "If you have trouble using the uploader, you can",
    "contactSupport": "contact support",
    "at": "at",
    "or": "or"
  },
  "criticalError": {
    "title": "Error",
    "dontHesitateToWrite": "If the problem persists, don't hesitate to write to us at",
    "orCall": "or call us at",
    "weWillTryOurBest": "We will do our best to assist you as soon as possible.",
    "errors": {
      "unknown": "An unknown error occurred. Our technical teams have been notified.\nYou can try to quit and relaunch the application.",
      "notPatient": "It seems you are authenticated with an account that is not a patient account.\nCurrently, only patient accounts can upload their pump data through this App.\nPlease log out and log in with a patient account."
    }
  },
  "usb": {
    "usbRequired": "Your browser is not compatible with the Stēto uploader",
    "usbRequiredInstructions": "USB features are required for this site.\nPlease use Chrome, Edge or Opera (download link below).",
    "downloadChrome": "Download Chrome",
    "downloadEdge": "Download Edge",
    "downloadOpera": "Download Opera"
  }
}
